export default __webpack_public_path__ + "static/media/sac_resto.62b356f9.jpeg";